<template>
  <div class="container-fluid">
    <label class="typo__label">Filter {{ filter }}</label>
    <div class="row">
      <div>
        <multiselect
          v-model="numberType[filter_number-1]"
          select-label=""
          deselect-label=""
          track-by="id"
          label="text"
          :preselect-first="true"
          :options="number_type_dropdown.data"
          :searchable="false"
          :show-labels="false"
          :allow-empty="false">
          <template slot="singleLabel" slot-scope="{ option }">{{ option.text }}</template>
        </multiselect>
      </div>

      <div>
        <multiselect
          v-model="numberOfPlayers[filter_number-1]"
          select-label=""
          deselect-label=""
          track-by="id"
          label="text"
          :preselect-first="true"
          :options="number_of_players_dropdown.data"
          :searchable="false"
          :show-labels="false"
          :allow-empty="false">
          <template slot="singleLabel" slot-scope="{ option }">{{ option.text }}</template>
        </multiselect>
      </div>

      <div>
        <multiselect
          v-model="playersSelected[filter_number-1]"
          :options="players"
          :multiple="true"
          :close-on-select="false"
          :clear-on-select="true"
          :hide-selected="true"
          :preserve-search="true"
          placeholder=""
          label="name"
          track-by="playerId"
          :preselect-first="false">
          <template slot="tag" slot-scope="props"><span class="custom__tag"><span>{{ props.option.name }}</span><span class="custom__remove" @click="props.remove(props.option)">❌</span></span></template>
        </multiselect>
      </div>

      <div class="col-md-2">
        <multiselect
          v-model="onOff[filter_number-1]"
          select-label=""
          deselect-label=""
          track-by="id"
          label="text"
          :preselect-first="true"
          :options="on_off_dropdown.data"
          :searchable="false"
          :show-labels="false"
          :allow-empty="false">
          <template slot="singleLabel" slot-scope="{ option }">{{ option.text }}</template>
        </multiselect>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import Multiselect from 'vue-multiselect'

export default {
  name: 'PlayerWowySelect',
  components: {
    Multiselect
  },
  props: ['filter', 'number_type_options', 'number_of_players_options', 'player_options', 'on_off_options', 'number_type', 'number_of_players', 'player_filter', 'on_off', 'filter_regex'],
  data () {
    return {
      filter_number: this.filter,
      number_type_dropdown: this.number_type_options,
      number_of_players_dropdown: this.number_of_players_options,
      players: this.player_options,
      on_off_dropdown: this.on_off_options,
      number_type_selected: this.number_type,
      number_of_players_selected: this.number_of_players,
      players_selected: this.player_filter,
      on_off_selected: this.on_off,
      player_filter_regex: this.filter_regex
    }
  },
  computed: {
    numberType: {
      get () {
        return this.number_type_selected
      },
      set (value) {
        this.number_type_selected = value
        this.$emit('input', value)
      }
    },
    numberOfPlayers: {
      get () {
        return this.number_of_players_selected
      },
      set (value) {
        this.number_of_players_selected = value
        this.$emit('input', value)
      }
    },
    playersSelected: {
      get () {
        return this.players_selected
      },
      set (value) {
        this.players_selected = value
        this.$emit('input', value)
      }
    },
    onOff: {
      get () {
        return this.on_off_selected
      },
      set (value) {
        this.on_off_selected = value
        this.$emit('input', value)
      }
    }
  },
  methods: {
    getPlayersSelected () {
      this.players_selected_strings = []
      for (var i = 0; i < this.players_selected.length; i++) {
        this.filter_type = this.number_type_selected[i].id + this.number_of_players_selected[i].id + this.on_off_selected[i].id
        this.players_selected_strings.push('')
        for (var j = 0; j < this.players_selected[i].length; j++) {
          if (j === 0) {
            this.players_selected_strings[i] += this.players_selected[i][j].playerId
          } else {
            this.players_selected_strings[i] += ',' + this.players_selected[i][j].playerId
          }
        }
      }
    },
    getPlayers (callbacks) {
      callbacks = callbacks || [function () {}]
      this.season_selected_string = this.getSeasonsSelectedString()

      var params = {}
      params[this.$teamIdParam] = this.team_selected.id
      params[this.$seasonParam] = this.season_selected_string
      params[this.$seasonTypeParam] = this.season_type_selected.id

      axios.get(process.env.API_BASE_URL + 'get-team-players-for-season', {
        params: params
      })
        .then((response) => {
          this.player_ids = Object.keys(response.data.players)
          this.players = []
          this.player_ids.forEach((playerId) => {
            this.players.push({'playerId': playerId, 'name': response.data.players[playerId]})
          })
          this.get_players = false
          callbacks.forEach((callback) => {
            callback()
          })
        }, (error) => {
          this.error = error
        })
    },
    addFiltersFromQueryParams () {
      Object.keys(this.$route.query).forEach((key) => {
        if (key.match(this.player_filter_regex) !== null) {
          this.number_of_filters += 1
          this.match = key.match(this.player_filter_regex)
          this.filter_player_ids = this.$route.query[key].split(',')

          this.filter_number_type = this.match[1]
          this.number_type_dropdown.data.forEach((numberType) => {
            if (numberType.id === this.filter_number_type) {
              this.number_type_selected.push(numberType)
            }
          })

          this.filter_on_off = this.match[2]
          this.on_off_dropdown.data.forEach((onOff) => {
            if (onOff.id === this.filter_on_off) {
              this.on_off_selected.push(onOff)
            }
          })

          this.filter_number_of_players = key.split(this.filter_number_type)[1].split(this.filter_on_off)[0]
          this.number_of_players_dropdown.data.forEach((numberOfPlayers) => {
            if (numberOfPlayers.id === this.filter_number_of_players) {
              this.number_of_players_selected.push(numberOfPlayers)
            }
          })

          this.players_selected.push([])

          this.filter_player_ids.forEach((filterPlayerId) => {
            this.players.forEach((player) => {
              if (player.playerId === filterPlayerId) {
                this.players_selected[this.players_selected.length - 1].push(player)
              }
            })
          })
          this.getPlayersSelected()
        }
      })
      if (this.players_selected.length === 0) {
        this.number_of_filters += 1
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/mixins/PlayerWowySelect.vue